// The word forms the booking panel and the customers register draw, read
// from lib/terminology (the one owner of the vocabulary: locales.json
// singulars + its documented derived forms). This file holds NO profile
// vocabulary of its own — it only bundles the terms into the `Words` shape
// the screens take, so JSX never branches on the profile.
//
// The gender helpers below are grammar on the API's `gender` field, not
// terminology (they do not change with the term profile).

import { countForms, countLabel, staffNoun, term, type CountForms, type StaffNoun, type TermProfile } from '@/lib/terminology';

export { countLabel };
export type { CountForms, StaffNoun };

export interface Words {
  /** المراجع / الزبون (definite, masculine). */
  customer: string;
  /** المراجعة / الزبونة (definite, feminine). */
  customerF: string;
  /** «مراجع» (indefinite) — «مراجع جديد». */
  customerIndef: string;
  /** «مراجعاً» — «أضفه مراجعاً جديداً». */
  customerAcc: string;
  /** «مراجعةً» — «أضفها مراجعةً جديدة». */
  customerAccF: string;
  customers: CountForms;
  /** الزيارات / المواعيد (column header, stat label). */
  appointmentsPlural: string;
  /** آخر زيارة / آخر موعد. */
  lastAppointment: string;
  appointments: CountForms;
  /** «زيارة أولى» / «موعد أول» (zero visits). */
  firstAppointment: string;
  /** The booking panel's service step: clinic «الزيارة», salon «الخدمة» (boards). */
  serviceStep: string;
}

export function wordsFor(profile: TermProfile): Words {
  return {
    customer: term('customer', profile),
    customerF: term('customer_f', profile),
    customerIndef: term('customer_indef', profile),
    customerAcc: term('customer_acc', profile),
    customerAccF: term('customer_acc_f', profile),
    customers: countForms('customer', profile),
    appointmentsPlural: term('appointments', profile),
    lastAppointment: term('last_appointment', profile),
    appointments: countForms('appointment', profile),
    firstAppointment: term('first_appointment', profile),
    serviceStep: term('service_step', profile),
  };
}

/** Feminine when the API says so; masculine (the grammatical default) otherwise. */
export function isFemale(gender?: string | null): boolean {
  return gender === 'female';
}

/** «لها» / «له». */
export function pronounFor(gender?: string | null): string {
  return isFemale(gender) ? 'لها' : 'له';
}

/** The staff step's noun — lib/terminology `staffNoun`. */
export function staffNounFor(profile: TermProfile, sector?: string | null): StaffNoun {
  return staffNoun(profile, sector);
}
